export const TEST_ID = 'fieldsIcon';
